/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_TypeInputs */

const en_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Type`)
};

const fr_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de média`)
};

const de_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medientyp`)
};

const it_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di supporto`)
};

const ru_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип носителя`)
};

const es_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de medio`)
};

const zh_cn2_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体类型`)
};

const ja_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアタイプ`)
};

const hi_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया प्रकार`)
};

const pt_pt2_media_type = /** @type {(inputs: Media_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de mídia`)
};

/**
* | output |
* | --- |
* | "Media Type" |
*
* @param {Media_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_type = /** @type {((inputs?: Media_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_type(inputs)
	if (locale === "de") return de_media_type(inputs)
	if (locale === "it") return it_media_type(inputs)
	if (locale === "ru") return ru_media_type(inputs)
	if (locale === "es") return es_media_type(inputs)
	if (locale === "zh-CN") return zh_cn2_media_type(inputs)
	if (locale === "ja") return ja_media_type(inputs)
	if (locale === "hi") return hi_media_type(inputs)
	if (locale === "pt-PT") return pt_pt2_media_type(inputs)
	return en_media_type(inputs)
});